import UnitSystem from './unit_system'

const UnitConverter = {
  _decimalPoints: 2,

  _ratios: {
    meters: {
      feet: 3.28084
    },
    km: {
      meters: 1000,
      miles: 0.621371,
      feet: 3280.84
    },
    miles: {
      meters: 1609.34,
      feet: 5280
    },
    kph: {
      mph: 0.621
    }
  },

  _getRatio(sourceUnit, targetUnit) {
    let ratio = this._ratios[sourceUnit] != null ? this._ratios[sourceUnit][targetUnit] : undefined
    if (ratio == null) {
      ratio = this._ratios[targetUnit] != null ? this._ratios[targetUnit][sourceUnit] : undefined
      if (ratio != null) {
        ratio = 1 / ratio
      }
    }
    return ratio
  },

  convert(value, sourceUnit, targetUnit) {
    if (sourceUnit === targetUnit) {
      return value
    } else {
      const ratio = this._getRatio(sourceUnit, targetUnit)
      if (ratio != null) {
        return this._fixDecimalPoints(value * ratio)
      } else {
        return null
      }
    }
  },

  _fixDecimalPoints(number) {
    number = number.toFixed(this._decimalPoints)
    return parseFloat(number, 10)
  },

  formatDistance(value, unit) {
    return this.format(value, unit, 'distance')
  },

  format(value, unit, type) {
    const systemName = UnitSystem.getCurrent().name
    const targetUnits = this._unitsBySystem[systemName][type]
    for (let i = 0; i < targetUnits.length; i++) {
      value = this.convert(value, unit, targetUnits[i])
      unit = targetUnits[i]
      if (value < 1000) {
        break
      }
    }

    return { value, unit }
  },

  _unitsBySystem: {
    metric: {
      distance: ['meters', 'km']
    },
    imperial: {
      distance: ['feet', 'miles']
    }
  }
}

export default UnitConverter
